import React from "react";
import { Link } from "react-router-dom";

const Terms: React.FC = () => (
  <div className="page legal-page">
    <h1>Terms of Service</h1>
    <p className="form-hint">Last updated: August 7, 2026 · Ticketed Wedding (Pash Company)</p>
    <div className="golden-thread" aria-hidden="true" />

    <div className="legal-body">
      <p>
        By using Ticketed Wedding you agree to these terms. This is a launch-ready stub for
        the website MVP; counsel-reviewed terms may supersede it before public launch.
      </p>

      <h2>The service</h2>
      <p>
        Ticketed Wedding is a marketplace where couples (&quot;Throwers&quot;) list weddings,
        manage guest lists and ticket tiers, and approve Public Seat requests from public
        guests (&quot;Goers&quot;). Invited guests may RSVP by name without an account.
      </p>

      <h2>Accounts &amp; roles</h2>
      <p>
        One account can host weddings and build a Goer profile. You are responsible for
        accurate listing information, guest list privacy, and lawful use of guest contact data.
      </p>

      <h2>Tickets &amp; payments</h2>
      <ul>
        <li>Payments are processed by Stripe; a platform fee applies to ticket sales.</li>
        <li>Public Seat payment is collected only after Thrower approval.</li>
        <li>Pending Public Seat requests expire after 72 hours; approved unpaid seats also
          expire after a 72-hour payment window and return to inventory.</li>
        <li>Refund policy will be published after legal review; until then, contact the
          Thrower and platform support for disputes.</li>
      </ul>

      <h2>Approvals &amp; conduct</h2>
      <p>
        Throwers control approval of Public Seats. We may suspend accounts for abuse, fraud,
        or misuse of guest data. Do not use the platform to harass or misrepresent yourself.
      </p>

      <h2>Disclaimer</h2>
      <p>
        The platform facilitates listings, RSVPs, and payments. We are not a party to the
        wedding event itself and are not liable for venue issues, guest disputes, or
        event cancellations beyond what applicable law requires.
      </p>

      <h2>Contact</h2>
      <p>
        See our <Link to="/privacy">Privacy Policy</Link>. For questions about these
        terms, email{" "}
        <a href="mailto:hello@ticketweddings.com">hello@ticketweddings.com</a>.
      </p>
    </div>
  </div>
);

export default Terms;
